export default __webpack_public_path__ + "static/media/textMiiClip.af5ae75f.mp4";